import { ApiTypes, api } from "../common";
import {
  AnalyticsData,
  DistributionType,
} from "~src/pages/brands/Detail/TrafficAndRevenue";
import { getLatestData } from "~src/pages/competitorAnalytics/utils";
import { CompetitorAds } from "~src/sections/competitorAnalytics/CompetitorAnalytics";
import { OverviewCharts, TrafficData } from "~src/types/brand";

const PRODUCT_PATHS: ApiTypes.API = {
  trafficSource: {
    path: `api/analytics/traffic-source/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  trafficCountry: {
    path: `api/analytics/traffic-country/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  audienceDemographics: {
    path: `api/analytics/audience-demographic/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  brandTrafficRevenue: {
    path: `api/analytics/brand-traffic-revenue/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  brandMetrics: {
    path: `api/analytics/brand-metrics/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  fbAds: {
    path: `api/analytics/facebook-ads/`,
    method: ApiTypes.HTTPMethod.GET,
  },
};

//----------------------------------------------------------------

export const getTrafficSource = async (brandId: number | undefined) => {
  const endpoint = PRODUCT_PATHS.trafficSource;

  const response = await api<AnalyticsData>({
    method: endpoint.method,
    url: `${endpoint.path}${brandId}/`,
  });
  return getLatestData(response.data);
};

export const getTrafficCountry = async (brandId: number | undefined) => {
  const endpoint = PRODUCT_PATHS.trafficCountry;

  const response = await api({
    method: endpoint.method,
    url: `${endpoint.path}${brandId}/`,
  });
  return getLatestData(response.data);
};

export const getAudienceDemographics = async (brandId: number | undefined) => {
  const endpoint = PRODUCT_PATHS.audienceDemographics;

  const response = await api<DistributionType>({
    method: endpoint.method,
    url: `${endpoint.path}${brandId}/`,
  });
  return getLatestData(response.data);
};

export const getBrandTrafficRevenue = async (brandId: number | undefined) => {
  const endpoint = PRODUCT_PATHS.brandTrafficRevenue;

  const response = await api<TrafficData>({
    method: endpoint.method,
    url: `${endpoint.path}${brandId}`,
  });
  return response.data;
};

export const getBrandMetrics = async (brandId: number | undefined) => {
  const endpoint = PRODUCT_PATHS.brandMetrics;

  const response = await api<OverviewCharts>({
    method: endpoint.method,
    url: `${endpoint.path}${brandId}`,
    params: { duration: 365 },
  });
  return response.data;
};

const EMPTY_COMPETITOR_ADS: CompetitorAds = {
  total_ads: 0,
  map_data: {},
  top_countries: [],
};

export const getFbAds = async (brandIds: string[] | undefined) => {
  // Validate brand IDs to prevent invalid API requests
  if (!brandIds || brandIds.length === 0) {
    return EMPTY_COMPETITOR_ADS;
  }

  // Filter out empty or invalid brand IDs
  const validIds = brandIds.filter((id) => id && id.trim());
  if (validIds.length === 0) {
    return EMPTY_COMPETITOR_ADS;
  }

  const endpoint = PRODUCT_PATHS.fbAds;
  const response = await api<CompetitorAds>({
    method: endpoint.method,
    url: endpoint.path,
    params: { brand_ids: validIds.join(", ") },
  });
  return response.data;
};
